import { VBadge } from 'vuetify/lib/components/VBadge';
import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,{staticClass:"ml-2",attrs:{"small":"","color":"#F5F5F5"}},[_c(VBadge,{staticClass:"ml-n1",attrs:{"color":_vm.compStateColour,"dot":"","inline":"","left":""}},[_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.compStateText))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }